import React from "react";
import { Box } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { ResponsivePage } from "../../../components/desktopUi";
import { MenuCard, MenuGrid } from "../../../components/managementUi";
import { appImages } from "../../../assets/appicons";
import { useEmployeeAuth } from "../../../auth/EmployeeAuthContext";
import { JOB_TITLE, isSupportDepartment } from "../../../utils/managerRole";
import { EMP_BASE_PATH } from "../../../config";

// Khớp app: app/(feature)/management/sell/index.tsx
const SellIndex = () => {
  const navigate = useNavigate();
  const { user } = useEmployeeAuth();
  const base = `${EMP_BASE_PATH}/quan-ly/ban-hang`;

  // Kiểm tra giao dịch: chỉ phòng hỗ trợ (kế toán/HC/CRM) và cấp cao hơn nhân viên.
  const jobPosition = user?.jobPosition?.code || "";
  const canCheckTransaction =
    isSupportDepartment(user?.supportDepartment?.code) ||
    (!!jobPosition && jobPosition !== JOB_TITLE.NHAN_VIEN);

  return (
    <ResponsivePage title="Quản lý bán hàng">
      <MenuGrid>
        <MenuCard icon={appImages.icon_booking} label="Booking" onClick={() => navigate(`${base}/booking`)} />
        <MenuCard icon={appImages.icon_looking} label="Locking" onClick={() => navigate(`${base}/locking`)} />
        <MenuCard icon={appImages.icon_HDMB} label="HDMB" onClick={() => navigate(`${base}/hdmb`)} />
        <MenuCard icon={appImages.icon_TTKQ} label="TTKQ" onClick={() => navigate(`${base}/ttkq`)} />
        <MenuCard
          icon={appImages.icon_thu_nhap}
          label="Thu nhập"
          onClick={() => navigate(`${EMP_BASE_PATH}/quan-ly/thu-nhap`)}
        />
        {canCheckTransaction ? (
          <MenuCard
            icon={appImages.icon_search}
            label="Kiểm tra giao dịch"
            onClick={() => navigate(`${base}/kiem-tra-giao-dich`)}
          />
        ) : null}
      </MenuGrid>
    </ResponsivePage>
  );
};

export default SellIndex;
